export default {
  LIST_FETCHED: 'WEBSITE_SECTIONS_FETCHED',
  LIST_LOAD: 'WEBSITE_SECTIONS_LOAD',
  ITEM_DETAIL: 'WEBSITE_SECTIONS_DETAIL',
  BUTTON_LOAD: 'WEBSITE_SECTIONS_BUTTON_LOAD',
};
